import { render } from "./DispatchDetail.vue?vue&type=template&id=9343f208&scoped=true"
import script from "./DispatchDetail.vue?vue&type=script&lang=js"
export * from "./DispatchDetail.vue?vue&type=script&lang=js"

import "./DispatchDetail.vue?vue&type=style&index=0&id=9343f208&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9343f208"]])

export default __exports__